function t(e) {
  return e !== "system" ? e : typeof window > "u" ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function r(e) {
  document.documentElement.classList.toggle("dark", t(e) === "dark");
}
export {
  r as applyTheme,
  t as resolveTheme
};
//# sourceMappingURL=apply-theme.js.map
